<!--     
    notificationId:string;
    notificationtitle:string;
    notificationdescription?:string;
    notificationimage?:string;
    datecreated:string;
    dateread?:string;
    dateviewed?:string;
    link?:string; -->
<div (mouseenter)="scheduleMarkAsRead()" (mouseleave)="cancelScheduledMarkAsRead()" class="notificationitem-control" [ngClass]="{'read': !newmsg}" matTooltip="{{ 'notificationitem.navigate' | trans }}" matTooltipPosition="left" matTooltipShowDelay="500">
    <a class="nav-link" (click)="navigate(notification?.link)">
    <div class="row">
        <div class="col">
            <h6 class="h6">{{notification.notificationtitle}}</h6>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <quill-view-html class="viewer" [content]="notification.notificationdescription" theme="snow"></quill-view-html>
        </div>
    </div>
<div class="row">
    <div *ngIf="newmsg" class="col">
        <p class="date-stamp">{{ 'notificationitem.create' | trans }} {{notification.datecreated | date:'dd-MM-yyyy'}}</p>
    </div>
    <div *ngIf="!newmsg" class="col">
        <p class="date-stamp">{{ 'notificationitem.read' | trans }} {{notification?.dateread | date:'dd-MM-yyyy'}}</p>
    </div>
</div>
    </a>
</div>

